/**
 * Used by Page.js and the Intercom Component to prepopulate the chat with a message
 * key: query parameter string
 * value: help message to prepopulate chat
 */

export const INTERCOM_CHAT = {
    change_dealership: "I was assigned a dealership, but I want to use a different dealer",
};
